// extracted by mini-css-extract-plugin
export default {"custom-icon":"DropdownIndicator_custom-icon__wdeGe","icon":"DropdownIndicator_icon__NL4HL","active":"DropdownIndicator_active__UR14p"};